export const URL_PARAMS = {
  messageId: 'email_message_id',
};

export const MACRO_EMAIL_SIGNATURE = '-- Sent with Macro';

export const MAX_ATTACHMENTS_BYTES_SIZE = 18_000_000;
